import type { FC } from 'react';
import { OverviewDashboard } from 'features/cabinet/dashboard';
import CabinetTitlePage from '../../../components/layout/CabinetTitlePage';

const OverviewDashboardPage: FC = () => (
  <>
    <CabinetTitlePage title={'Overview'} />
    <OverviewDashboard />
  </>
);

export default OverviewDashboardPage;
